/**
 * Decide which attribute should be selected on the Attribute Value tab after
 * the attribute list is (re)loaded from the server.
 *
 * Preservation over reset:
 *   If the user was already on an attribute that still exists in the refreshed
 *   list, keep them there — otherwise Save and Sort feel like the page
 *   "jumps back to the first attribute" even when the row they were reviewing
 *   is still present. When preserved, the returned object is the *refreshed*
 *   copy so any isReviewed / isConsidered changes from the save are visible.
 *
 * Fallback when the previous selection is gone (e.g. filtered out, deleted,
 * or first entry into the tab):
 *   1. First attribute that is both reviewed and considered.
 *   2. First attribute overall.
 *   3. null (empty list).
 */
export const pickAttributeToSelect = (
    sortedAttributes: MappingAttribute[],
    previous: MappingAttribute | null | undefined
): MappingAttribute | null => {
    if (previous) {
        const match = sortedAttributes.find(attr => attr.attribute === previous.attribute);
        if (match) return match;
    }

    const reviewedAndConsidered = sortedAttributes.find(
        attr => attr.isReviewed !== false && attr.isConsidered !== false
    );
    if (reviewedAndConsidered) return reviewedAndConsidered;

    return sortedAttributes[0] ?? null;
};
